import React, { useState } from 'react';
import { BottomSheet } from '../ui/BottomSheet';
interface AddBorrowedItemSheetProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (input: {
    itemName: string;
    borrowedTo: string;
    dateBorrowed: string;
    returnDeadline?: string;
  }) => void;
}
function getDefaultDate(): string {
  return new Date().toISOString().slice(0, 10);
}
export function AddBorrowedItemSheet({
  isOpen,
  onClose,
  onSubmit
}: AddBorrowedItemSheetProps) {
  const [itemName, setItemName] = useState('');
  const [borrowedTo, setBorrowedTo] = useState('');
  const [dateBorrowed, setDateBorrowed] = useState(getDefaultDate());
  const [returnDeadline, setReturnDeadline] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const name = itemName.trim();
    const to = borrowedTo.trim();
    if (!name || !to || !dateBorrowed) return;
    onSubmit({
      itemName: name,
      borrowedTo: to,
      dateBorrowed: new Date(dateBorrowed).toISOString(),
      returnDeadline: returnDeadline ? new Date(returnDeadline).toISOString() : undefined
    });
    setItemName('');
    setBorrowedTo('');
    setDateBorrowed(getDefaultDate());
    setReturnDeadline('');
    onClose();
  };
  return <BottomSheet isOpen={isOpen} onClose={onClose} title="New borrowed item" data-id="element-13" data-mp="3opbkhe31uiba">
      <form onSubmit={handleSubmit} className="space-y-4" data-id="element-14" data-mp="3tnd543g4ipov">
        <div data-id="element-15" data-mp="3towo41t5zeuc">
          <label htmlFor="item-name" className="mb-1.5 block text-sm font-medium text-slate-700" data-id="element-16" data-mp="2vzl6r65bxifp">
            Item
          </label>
          <input id="item-name" type="text" value={itemName} onChange={e => setItemName(e.target.value)} placeholder="e.g. Cordless drill" autoFocus className="w-full rounded-xl border border-slate-200 px-4 py-3 text-sm text-slate-900 placeholder:text-slate-400 focus:border-amber-500 focus:outline-none focus:ring-2 focus:ring-amber-100" data-id="element-17" data-mp="30zhd3c1i1lyf" />
        </div>
        <div data-id="element-18" data-mp="papzxanrhvl5">
          <label htmlFor="borrowed-to" className="mb-1.5 block text-sm font-medium text-slate-700" data-id="element-19" data-mp="2m99gn4s2gg6t">
            Lent to
          </label>
          <input id="borrowed-to" type="text" value={borrowedTo} onChange={e => setBorrowedTo(e.target.value)} placeholder="e.g. Sam" className="w-full rounded-xl border border-slate-200 px-4 py-3 text-sm text-slate-900 placeholder:text-slate-400 focus:border-amber-500 focus:outline-none focus:ring-2 focus:ring-amber-100" data-id="element-20" data-mp="2h9n30u8bsxxh" />
        </div>
        <div className="flex gap-3" data-id="element-21" data-mp="1ylrrlh06rw7j">
          <div className="flex-1" data-id="element-22" data-mp="2cb22sut2qe91">
            <label htmlFor="date-borrowed" className="mb-1.5 block text-sm font-medium text-slate-700" data-id="element-23" data-mp="2cc3mtos2ib2w">
              Date lent
            </label>
            <input id="date-borrowed" type="date" value={dateBorrowed} onChange={e => setDateBorrowed(e.target.value)} className="w-full rounded-xl border border-slate-200 px-3 py-3 text-sm text-slate-900 focus:border-amber-500 focus:outline-none focus:ring-2 focus:ring-amber-100" data-id="element-24" data-mp="1jv13aixszf96" />
          </div>
          <div className="flex-1" data-id="element-25" data-mp="3vc4bmlqstjas">
            <label htmlFor="return-deadline" className="mb-1.5 block text-sm font-medium text-slate-700" data-id="element-26" data-mp="3hj4vchj6zl26">
              Return by <span className="text-slate-400" data-id="element-27" data-mp="3mirawxmhtde5">(optional)</span>
            </label>
            <input id="return-deadline" type="date" value={returnDeadline} onChange={e => setReturnDeadline(e.target.value)} className="w-full rounded-xl border border-slate-200 px-3 py-3 text-sm text-slate-900 focus:border-amber-500 focus:outline-none focus:ring-2 focus:ring-amber-100" data-id="element-28" data-mp="e1d0mvdo8n0a" />
          </div>
        </div>
        <button type="submit" disabled={!itemName.trim() || !borrowedTo.trim()} className="w-full rounded-xl bg-amber-600 py-3 text-sm font-semibold text-white transition-colors duration-150 hover:bg-amber-700 disabled:cursor-not-allowed disabled:bg-slate-200 disabled:text-slate-400" data-id="element-29" data-mp="2otedpyicq11b">
          Add item
        </button>
      </form>
    </BottomSheet>;
}